module.exports = __webpack_public_path__ + "static/media/shutterstock_1020957880.46dde578.jpg";